<template>
<div class="luck-draw-box">
  <div v-for="item of list" :class="{ item: true, active: Object.is(item.index, activeIndex) }" :key="item.index">
    <div class="content">
      <img v-lazy="item.img" alt="">
      <span>{{item.label}}</span>
    </div>
  </div>
</div>
</template>
<script>
const list = []
for (let i = 0; i < 9; i++) {
  list.push({
    index: i + 1,
    img: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1592987777157&di=b02dbcd27c763a6c92b97cd42aaaeb9b&imgtype=0&src=http%3A%2F%2F5b0988e595225.cdn.sohucs.com%2Fq_70%2Cc_zoom%2Cw_640%2Fimages%2F20180528%2Fa1b4ada633364028bbd68f0ea8dfa0d2.jpeg',
    label: '鲜花一蓝'
  })
}
export default {
  data () {
    return {
      list,
      activeIndex: -1
    }
  }
}
</script>
<style lang="scss" scoped>
.luck-draw-box {
  width: 90vw;
  margin: 10px auto;
  .item {
    width: 30vw;
    height: 30vw;
    box-sizing: border-box;
    display: inline-block;
    background: #fff;
    padding: 8px;
    .content{
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      box-shadow: 0 5px 0 #22b5ff;
      img {
        width: 50px;
        height: 50px;
      }
      span {
        color: #708abf;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        margin-top: 6px;
      }
    }
  }
  .active {
    .content {
      background: red;
    }
    span {
      color: #fff;
    }
  }
}
</style>
